<p>base-component works!</p>
